import type { Country } from '../../../model';
import { MAX_LENGTH_OFFSET } from '../../constants';

export const isPhoneLengthValid = (digitsLength: number, country: Country): boolean =>
  digitsLength >= country.minLength && digitsLength <= country.minLength + MAX_LENGTH_OFFSET;
